import AppAPI from '@/api'

export default {
  data () {
    return {
      isInitialized: false,
      isRequesting: false,
      dialogErrorVisible: false,
      error: {
        title: '',
        message: ''
      }
    }
  },
  computed: {
    post: {
      get () { return this.$store.getters['wordpress/posts/selected'] }
    },
    posts: {
      get () { return this.$store.getters['wordpress/posts/all'] }
    },
    publishedPosts: {
      get () { return this.$store.getters['wordpress/posts/published'] }
    },
    page: {
      get () { return this.$store.getters['wordpress/pages/selected'] }
    },
    pages: {
      get () { return this.$store.getters['wordpress/pages/all'] }
    },
    publishedPages: {
      get () { return this.$store.getters['wordpress/pages/published'] }
    },
    media: {
      get () { return this.$store.getters['wordpress/media/all'] }
    },
    themes: {
      get () { return this.$store.getters['wordpress/themes/all'] }
    },
    settings: {
      get () { return this.$store.getters['wordpress/settings/all'] }
    }
  },
  methods: {
    /**
     * コンポーネント名をIDから取得
     */
    getComponentNameById: function (id) {
      return AppAPI.components[id] ? AppAPI.components[id].meta.name : null
    },

    /**
     * コンポーネントのメタ情報をIDから取得
     */
    getComponentMetaById: function (id) {
      return AppAPI.components[id] ? AppAPI.components[id].meta : null
    },

    /**
     * pageをWP APIに問い合わせる
     */
    // requestPage: async function (id) {
    //   if (this.page) return Promise.resolve(this.page)
    //   const response = await this.$store.dispatch('wordpress/getPage', id)
    //   if (response.error) {
    //     this.error.title = `${response.code} Error: ${response.status}`
    //     this.error.message = `固定ページ読み込み時の${response.message}`
    //     this.dialogErrorVisible = true
    //     this.isRequesting = false
    //   }
    //   return Promise.resolve(response)
    // },

    /**
     * postsをWP APIに問い合わせる
     */
    requestPosts: async function () {
      return new Promise(async (resolve, reject) => {
        // すでにWP APIからデータを取得ずみならresolveして返す
        if (this.posts.length > 0) {
          resolve(this.posts)
          return true
        }

        // WP APIに問い合わせてデータを取得する
        const response = await this.$store.dispatch('wordpress/posts/fetch')
        if (response.error) {
          this.$msgbox({
            title: '投稿の読み込みに失敗しました',
            message: `${response.message}\n\n ${response.status} error: ${response.statusText}`,
            confirmButtonText: 'OK'
          })
          this.isRequesting = false
          reject(response.error)
        }
        resolve(response)
      })
    },

    /**
     * pagesをWP APIに問い合わせる
     */
    requestPages: async function () {
      return new Promise(async (resolve, reject) => {
        // すでにWP APIからデータを取得ずみならresolveして返す
        if (this.pages.length > 0) {
          resolve(this.pages)
          return true
        }

        // WP APIに問い合わせてデータを取得する
        const response = await this.$store.dispatch('wordpress/pages/fetch')
        if (response.error) {
          this.$msgbox({
            title: '固定ページの読み込みに失敗しました',
            message: `${response.message}\n\n ${response.status} error: ${response.statusText}`,
            confirmButtonText: 'OK'
          })
          this.isRequesting = false
          reject(response.error)
        }
        resolve(response)
      })
    },

    /**
     * mediaをWP APIに問い合わせる
     */
    requestMedia: async function () {
      return new Promise(async (resolve, reject) => {
        // すでにWP APIからデータを取得ずみならresolveして返す
        if (this.media.length > 0) {
          resolve(this.media)
          return true
        }

        // WP APIに問い合わせてデータを取得する
        const response = await this.$store.dispatch('wordpress/media/fetch')
        if (response.error) {
          this.$msgbox({
            title: 'アップロード画像の読み込みに失敗しました',
            message: `${response.message}\n\n ${response.status} error: ${response.statusText}`,
            confirmButtonText: 'OK'
          })
          this.isRequesting = false
          reject(response.error)
        }
        resolve(response)
      })
    },

    /**
     * themesをWP APIに問い合わせる
     */
    requestThemes: async function () {
      return new Promise(async (resolve, reject) => {
        // すでにWP APIからデータを取得ずみならresolveして返す
        if (this.$store.getters['wordpress/status/isThemesLoaded']) {
          resolve(this.themes)
          return true
        }

        // WP APIに問い合わせてデータを取得する
        const response = await this.$store.dispatch('wordpress/themes/fetch')
        if (response.error) {
          this.$msgbox({
            title: 'テーマデータの読み込みに失敗しました',
            message: `${response.message}\n\n ${response.status} error: ${response.statusText}`,
            confirmButtonText: 'OK'
          })
          this.isRequesting = false
          reject(response.error)
          return false
        }
        this.$store.commit('wordpress/status/themesLoaded')
        resolve(response)
      })
    },

    /**
     * settingsをWP APIに問い合わせる
     */
    requestSettings: async function () {
      return new Promise(async (resolve, reject) => {
        // すでにWP APIからデータを取得ずみならresolveして返す
        if (this.$store.getters['wordpress/status/isSettingsLoaded']) {
          resolve(this.settings)
          return true
        }

        // WP APIに問い合わせてデータを取得する
        const response = await this.$store.dispatch('wordpress/settings/fetch')
        if (response.error) {
          this.$msgbox({
            title: '設定データの読み込みに失敗しました',
            message: `${response.message}\n\n ${response.status} error: ${response.statusText}`,
            confirmButtonText: 'OK'
          })
          this.isRequesting = false
          reject(response.error)
          return false
        }
        this.$store.commit('wordpress/status/settingsLoaded')
        resolve(response)
      })
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getCssColorsValue: function (type) {
      return `rgba(${this.themes.colors[type].rgba.r}, ${this.themes.colors[type].rgba.g}, ${this.themes.colors[type].rgba.b}, ${this.themes.colors[type].rgba.a})`
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function (prop, type) {
      return `${prop}: ${this.getCssColorsValue(type)}`
    },

    /**
     * テーマカラー用のCSSを用意する
     */
    getCssForThemeColors: function () {
      return ['base', 'main', 'accent'].reduce((curr, type) => {
        return curr + `.theme-${type}-color {${this.getThemeInlineStyle('color', type)}}.theme-${type}-color-hover:hover {${this.getThemeInlineStyle('color', type)}}.theme-${type}-bg-color {${this.getThemeInlineStyle('background-color', type)}}.theme-${type}-bg-color-hover:hover {color: #fff; ${this.getThemeInlineStyle('background-color', type)}}.theme-${type}-border-color {${this.getThemeInlineStyle('border-color', type)}}.theme-${type}-fill-color {${this.getThemeInlineStyle('fill', type)}}`
      }, '')
    },

    /**
     * テーマカラー用のCSSをhead要素内のstyle要素に注入する
     */
    injectThemeColorsStyle: function () {
      const head = document.head
      const style = document.createElement('style')
      style.type = 'text/css'
      if (style.styleSheet) {
        style.styleSheet.cssText = this.getCssForThemeColors()
      } else {
        style.appendChild(document.createTextNode(this.getCssForThemeColors()))
      }
      head.appendChild(style)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/RouteBase.js